<template>
    <v-container>
      <v-card class="mx-auto pa-4">
        <p class="display-1 text--primary">
          <v-icon>camera_alt</v-icon>
          Ah-hoc Scans
        </p>
        <v-data-table
            dense
            :headers="headers"
            :options.sync="options"
            :must-sort=true

            @click:row="rowClicked"
            
            :items="items"
            :server-items-length="totalAdhocScans"

            :footer-props="{
                itemsPerPageOptions: [10,20,100,300,-1]
            }"

            loading-text="Loading...please wait"
            :loading="loadingAdhocScans"
        >

          <template v-slot:item.scanEndDateTime="{ item }">
            {{ item.scanEndDateTime | toFriendlyDate('In Progress') }}
          </template>

          <template v-slot:item.inputFileName="{ item }">
            {{ item.inputFileName  }}
            <v-icon v-if="item.downloadInProgress" class="rotating">mdi-loading</v-icon>
          </template>

        </v-data-table>
      </v-card>
    </v-container>
</template>


<script>
    import {AdhocScansService} from '../../services/api/adhocScans';
    const apiAdhocScans = new AdhocScansService();

    // HACK:  import axios so we can send the user directly to the api to get Excel files.
    import axios from 'axios';
  import ApiClient from '../../services/api/apiClient';

  export default {
    data () {
      
      return {
        loadingAdhocScans: true,
        totalAdhocScans: 0,
        items: [],
        options: {},

        headers: [
            // HACK:  use ' d-none' (note the leading space) to hide the column.
            { text: 'ID', value: 'id', hidden: true,  align: ' d-none'  },
            { text: 'Input File', value: 'inputFileName', sortable: false },
            { text: 'Completed', value: 'scanEndDateTime' },
            { text: 'Snapshots', value: 'snapshotCount', align: 'end' },
        ],
      }
    },

    watch: {
      options: {
          handler () {
              this.getAdhocScans();
              },
          deep: true,
      },
    },

    methods: {

      getAdhocScans () {
        this.loadingAdhocScans = true;

        // Clear our list so the loading text will be shown.
        this.items = [];

        // Set up our search, sort, and paging parameters
        const search = {
          // If there's a sortBy field set, then use it; otherwise use a reasonable default.
          sortOrderField: this.options.sortBy.length == 1 ? this.options.sortBy[0] : "ScanEndDateTime",
          // If there's no sortDesc defined, sort by desc.  Otherwise sort by the value.
          sortDirection: this.options.sortDesc.length == 0 ? "desc" : (this.options.sortDesc[0] ? "desc" : "asc"),
          itemsPerPage: this.options.itemsPerPage,
          itemsToSkip: this.options.itemsPerPage * (this.options.page - 1),
        }

        // Get the list of ad hoc scans.
        apiAdhocScans.getAdhocScans(search).then((data) => {
            this.items = data.items
            this.totalAdhocScans = data.totalItemCount;
        });

        this.loadingAdhocScans = false;
      },

        // When a row is clicked, go to the detail page.
        async rowClicked(item) {
            // TODO:  Figure out how to link straight to the api call.
            //this.$router.push({ name: "AdhocScan", params: { id : item.id } });
            //window.open('http://www.google.com');
            // TODO:  Get the URL from the object or the api service, not this hard-coded crap.

            if (item.downloadInProgress) {
              return; // Prevent multiple clicks while download is in progress
            }
            try {
              item.downloadInProgress = true;
              this.$forceUpdate();

              await ApiClient.downloadFile(axios.defaults.baseURL + 'api/adhocScans/ExcelExport/' + item.id, item.inputFileName || 'AdhocScan-' + item.id + '.xlsx');
            } finally {
              item.downloadInProgress = false;
              this.$forceUpdate();
            }
        },
    }
  }
</script>

<style scoped>
.rotating {
  animation: rotation 1s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>